import { FIELD_PATH_SEPARATOR } from './form-view';
// An unchecked checkbox (false) and an empty selection ([]) count as empty, so
// a selection made before hydration can fill them.
export const isEmptyInputValue = (value)=>value === undefined || value === null || value === '' || value === false || Array.isArray(value) && value.length === 0;
const isNested = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
const fill = (values, [key, ...rest], value)=>{
    const current = values[key];
    if (rest.length === 0) {
        return isEmptyInputValue(current) ? {
            ...values,
            [key]: value
        } : values;
    }
    if (!isEmptyInputValue(current) && !isNested(current)) {
        return values;
    }
    const nested = isNested(current) ? current : {};
    const filled = fill(nested, rest, value);
    return filled === nested ? values : {
        ...values,
        [key]: filled
    };
};
const read = (values, [key, ...rest])=>{
    const current = values[key];
    if (rest.length === 0) {
        return current;
    }
    return isNested(current) ? read(current, rest) : undefined;
};
export const mergePrehydrationValues = (values, pending)=>{
    let result = values;
    for (const [path, value] of pending){
        result = fill(result, path.split(FIELD_PATH_SEPARATOR), value);
    }
    return result;
};
export const prunePrehydrationValues = (values, pending)=>{
    for (const path of pending.keys()){
        if (!isEmptyInputValue(read(values, path.split(FIELD_PATH_SEPARATOR)))) {
            pending.delete(path);
        }
    }
};
export const forgetPrehydrationValues = (pending, previousValues, nextValues)=>{
    for (const path of pending.keys()){
        const segments = path.split(FIELD_PATH_SEPARATOR);
        if (read(previousValues, segments) !== read(nextValues, segments)) {
            pending.delete(path);
        }
    }
};

//# sourceMappingURL=prehydration-values.js.map